/**
 * Counts the number of occurrences of each value associated with the given key in the array.
 * @param {Array} array - The array to count values in.
 * @param {string} key - The key to get values from each item in the array.
 * @returns {Object} An object containing the counts of each value.
 */

export function countItemsByValue(array, key) {
  const counts = {};

  for (let item of array) {
    const value = item?.[key];

    if (value) {
      if (counts[value] === undefined) {
        counts[value] = 1;
      } else {
        counts[value]++;
      }
    }
  }

  // Create an array of objects with name and value properties for each count.
  const countArray = Object.keys(counts).map((name) => ({
    name,
    value: counts[name],
  }));

  return countArray;
}
